import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import {
  ChevronLeft,
  ChevronRight,
  ArrowLeft,
  Calendar,
  User,
  Clock,
  Bookmark,
  Share2,
  ArrowRight,
  ThumbsUp,
  ThumbsDown
} from "lucide-react";
import { useLazyGetNewsletterByNewsletterIdQuery } from "../api/businessApi";
const STORAGE_KEY = 'newsletter_reactions';

const Newsletter = () => {
  const { newsletterId } = useParams();
  const navigate = useNavigate();
  const [currentImage, setCurrentImage] = useState(0);
  // const [isSaved, setIsSaved] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const [getNewsletter, { data: newsletter, isLoading, error }] =
    useLazyGetNewsletterByNewsletterIdQuery();
  // const [likeNewsletter] = useLikeNewsletterMutation();
  // const [dislikeNewsletter] = useDislikeNewsletterMutation();

  useEffect(() => {
    if (newsletterId) getNewsletter(newsletterId);
  }, [newsletterId, getNewsletter]);

  // Redirect to new resource page if the newsletter has a slug
  useEffect(() => {
    if (newsletter?.slug) {
      navigate(`/resource/${newsletter.slug}`, { replace: true });
    }
  }, [newsletter, navigate]);

  const handleImageChange = (newIndex) => {
    if (!newsletter?.images) return;
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentImage(newIndex);
      setIsAnimating(false);
    }, 300);
  };
  useEffect(() => {
    if (!newsletter?.images || newsletter.images.length <= 1) return;

    const interval = setInterval(() => {
      handleImageChange(
        currentImage === newsletter.images.length - 1
          ? 0
          : currentImage + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [newsletter?.images, currentImage]);


  const prevImage = () => {
    if (!newsletter?.images || newsletter.images.length === 0) return;
    const newIndex = currentImage === 0
      ? newsletter.images.length - 1
      : currentImage - 1;
    handleImageChange(newIndex);
  };

  const nextImage = () => {
    if (!newsletter?.images || newsletter.images.length === 0) return;
    const newIndex = currentImage === newsletter.images.length - 1
      ? 0
      : currentImage + 1;
    handleImageChange(newIndex);
  };
  const userReaction = newsletter?.id
    ? hasReacted(newsletter.id)
    : null;

  // const isLiked = userReaction === 'like';
  // const isDisliked = userReaction === 'dislike';

  const goToImage = (index) => {
    if (!newsletter?.images || index < 0 || index >= newsletter.images.length) return;
    handleImageChange(index);
  };

  function getReactions() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  }

  function hasReacted(newsletterId) {
    const reactions = getReactions();
    return reactions[newsletterId];
  }

  function saveReaction(newsletterId, type) {
    const reactions = getReactions();
    reactions[newsletterId] = type;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(reactions));
  }

  // async function handleLike(newsletterId) {
  //   const reaction = hasReacted(newsletterId);
  //   if (reaction) {
  //     alert('You already reacted to this newsletter');
  //     return;
  //   }

  //   await likeNewsletter(newsletterId)
  //   saveReaction(newsletterId, 'like');
  // }

  // async function handleDislike(newsletterId) {
  //   const reaction = hasReacted(newsletterId);
  //   if (reaction) {
  //     alert('You already reacted to this newsletter');
  //     return;
  //   }

  //   await dislikeNewsletter(newsletterId)
  //   saveReaction(newsletterId, 'dislike');
  // }


  // const handleSave = () => {
  //   setIsSaved(!isSaved);
  //   // TODO: Add API call to save/unsave article
  // };

  const handleShare = () => {
    setShowShareMenu(!showShareMenu);
    // TODO: Add share functionality
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    setShowShareMenu(false);
    // TODO: Show toast notification
  };

  const shareOnSocial = (platform) => {
    if (!newsletter?.title) return;
    const url = window.location.href;
    const text = newsletter.title;

    switch (platform) {
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'linkedin':
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}&title=${encodeURIComponent(text)}`, '_blank');
        break;
    }
    setShowShareMenu(false);
  };

  if (error || !newsletter) {
    return (
      <div className="min-h-screen flex items-center justify-center text-center">
        <div>
          <h2 className="text-2xl font-bold mb-4">
            {error?.error === 'Newsletter not found' ? 'Newsletter not found' : 'Article not found'}
          </h2>
          <p className="text-gray-600 mb-4">
            {error?.error === 'Newsletter not found'
              ? 'The newsletter you\'re looking for doesn\'t exist or has been removed.'
              : 'This article is currently not available.'
            }
          </p>
          <Link to="/newsletter" className="text-[#135879] hover:underline">
            Back to newsletters
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#f4f6f8] min-h-screen">
      <div className="bg-[#135879] text-white">
        <div className="container mx-auto px-6 py-3 flex justify-end">
          <Link
            to="/newsletter"
            className="flex items-center text-sm hover:underline"
          >
            <ArrowLeft size={16} className="mr-1" /> back
          </Link>
        </div>
      </div>
      <div className="bg-white rounded-2xl shadow-lg max-w-5xl my-8 mx-auto">
        <div className="">
          {newsletter?.images?.length > 0 && (
            <div className="relative bg-white rounded-2xl shadow-lg overflow-hidden">
              <img
                src={newsletter.images[currentImage]}
                alt={newsletter.title}
                className={`w-full h-[420px] object-cover
    transition-all duration-300 ease-in-out
    ${isAnimating
                    ? 'opacity-0 scale-105'
                    : 'opacity-100 scale-100'}
  `}
              />

              {newsletter.images.length > 1 && (
                <>
                  <button
                    onClick={prevImage}
                    className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow hover:bg-white"
                  >
                    <ChevronLeft />
                  </button>

                  <button
                    onClick={nextImage}
                    className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow hover:bg-white"
                  >
                    <ChevronRight />
                  </button>
                </>
              )}

              {newsletter.images.length > 1 && (
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                  {newsletter.images.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => goToImage(index)}
                      className={`w-2 h-2 rounded-full transition-all ${index === currentImage
                        ? 'bg-white w-8'
                        : 'bg-white/50 hover:bg-white/75'
                        }`}
                    />
                  ))}
                </div>
              )}
            </div>
          )}

        </div>

        <div className="container mx-auto px-12 pt-14">
          <div className="text-center">
            <span className="inline-block mb-4 px-4 py-1 rounded-full bg-gray-200 text-xs tracking-widest uppercase text-gray-600">
              {newsletter?.category}
            </span>

            <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-6">
              {newsletter?.title}
            </h1>

            {newsletter?.excerpt && (
              <p className="text-lg text-gray-600 mb-6">
                {newsletter?.excerpt}
              </p>
            )}

            <div className="flex items-center justify-center gap-6 text-gray-500 text-sm mb-10">
              <span className="flex items-center gap-1">
                <User size={14} /> {newsletter?.author}
              </span>
              <span className="flex items-center gap-1">
                <Calendar size={14} />
                {new Date(newsletter?.publish_date).toLocaleDateString()}
              </span>
              <span className="flex items-center gap-1">
                <Clock size={14} /> {newsletter?.read_time}
              </span>
            </div>

            <hr className="border-gray-300" />
          </div>
        </div>

        <div className="container mx-auto px-12 py-12">
          <div
            className="prose prose-lg max-w-none
              prose-headings:font-serif
              prose-headings:text-gray-900
              prose-p:text-gray-700
              prose-a:text-[#135879]
              prose-a:hover:text-[#0f4568]
              prose-strong:hover:text-[#135879]"
            dangerouslySetInnerHTML={{ __html: newsletter?.content }}
          />

          <div className="flex items-center justify-between border-t border-gray-200 pt-6 mt-12">
            <div className="flex gap-3 relative">
              {/* <button
                disabled={!!userReaction}
                onClick={() => handleLike(newsletter.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-all
    ${isLiked
                    ? 'bg-red-100 text-red-600'
                    : 'bg-gray-100 hover:bg-red-100 hover:text-red-600'}
    disabled:opacity-60 disabled:cursor-not-allowed
  `}
              >
                <ThumbsUp
                  size={16}
                  className={isLiked ? 'fill-current' : ''}
                />
                {newsletter?.likes}
              </button>

              <button
                disabled={!!userReaction}
                onClick={() => handleDislike(newsletter.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-all
    ${isDisliked
                    ? 'bg-gray-300 text-gray-700'
                    : 'bg-gray-100 hover:bg-gray-300 hover:text-gray-700'}
    disabled:opacity-60 disabled:cursor-not-allowed
  `}
              >
                <ThumbsDown
                  size={16}
                  className={isDisliked ? 'fill-current' : ''}
                />
                {newsletter?.dislikes}
              </button> */}
              {/* <button
                onClick={handleSave}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-colors duration-200 ${isSaved
                  ? 'bg-blue-100 text-blue-600'
                  : 'bg-gray-100 hover:bg-blue-100 hover:text-blue-600'
                  }`}
              >
                <Bookmark size={16} className={isSaved ? 'fill-current' : ''} />
                {isSaved ? 'Saved' : 'Save'}
              </button> */}
              <div className="relative">
                <button
                  onClick={handleShare}
                  className="flex items-center gap-2 px-4 py-2 rounded-full bg-gray-100 hover:bg-green-100 hover:text-green-600 text-sm transition-colors duration-200"
                >
                  <Share2 size={16} /> Share
                </button>

                {showShareMenu && (
                  <div className="absolute top-full mt-2 right-0 bg-white rounded-lg shadow-lg border border-gray-200 p-2 z-50 min-w-[200px]">
                    <button
                      onClick={copyToClipboard}
                      className="flex items-center gap-2 w-full px-3 py-2 text-left hover:bg-gray-100 rounded transition-colors"
                    >
                      <Share2 size={14} /> Copy Link
                    </button>
                    <button
                      onClick={() => shareOnSocial('twitter')}
                      className="flex items-center gap-2 w-full px-3 py-2 text-left hover:bg-gray-100 rounded transition-colors"
                    >
                      <Share2 size={14} /> Share on Twitter
                    </button>
                    <button
                      onClick={() => shareOnSocial('facebook')}
                      className="flex items-center gap-2 w-full px-3 py-2 text-left hover:bg-gray-100 rounded transition-colors"
                    >
                      <Share2 size={14} /> Share on Facebook
                    </button>
                    <button
                      onClick={() => shareOnSocial('linkedin')}
                      className="flex items-center gap-2 w-full px-3 py-2 text-left hover:bg-gray-100 rounded transition-colors"
                    >
                      <Share2 size={14} /> Share on LinkedIn
                    </button>
                  </div>
                )}
              </div>
            </div>

            <Link
              to="/newsletter"
              className="flex items-center gap-1 text-sm text-[#135879] hover:text-[#0f4568] transition-colors duration-200"
            >
              More Articles <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
